module.exports = __webpack_public_path__ + "src/assets/img/share/tips/extroversion/127545bfaa168ca8fc4a48394e9d7f26.png";